import React, { useEffect, useMemo, useState } from "react";
import { withRouter } from "react-router-dom";
import { CardBody, Row, Col } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useGetActivityListQuery } from "../../../../store/api/userManagementApi";
import "../styles.css";
import { useSelector } from "react-redux";
import { FaRegCopy } from "react-icons/fa";

function ActivityList({ refreshKey }) {
  console.log("Rendering ActivityList");
  const [datas, setDatas] = useState([]);
  const userData = useSelector(state => state.userManagement.userData) || {};
  const user_id = userData?.user_id;
  const {
    data: activityResponse,
    error,
    refetch
  } = useGetActivityListQuery(user_id, { skip: !user_id });

  useEffect(() => {
    if (activityResponse && activityResponse.success && activityResponse.data) {
      setDatas(activityResponse.data);
    } else {
      setDatas([]);
    }
  }, [activityResponse]);

  useEffect(() => {
    if (error) {
      console.error("Error fetching activity data:", error);
      setDatas([]);
    }
  }, [error]);

  useEffect(() => {
    if (typeof refreshKey !== "undefined" && user_id) {
      refetch();
    }
  }, [refreshKey, user_id, refetch]);

  const handleCopyNote = async (value) => {
    const textToCopy = value || "";
    if (!textToCopy) return;

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(textToCopy);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }
    } catch (copyError) {
      console.error("Unable to copy note content", copyError);
    }
  };

  const report = useMemo(() => {
    return (datas || []).map((element, index) => ({
      ...element,
      slno: index + 1,
      actionTypeText: element.action_type || "Unknown",
      userRoleText: element.user_role || "Unknown",
    }));
  }, [datas]);

  const columns = [
    {
      dataField: "actionTypeText",
      text: "Action Type",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
    },
    {
      dataField: "note",
      text: "Note",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
      formatter: (cell, row) => (
        <div className="activity-note-cell">
          <span className="activity-note-text" title={cell || "-"}>
            {cell || "-"}
          </span>
          {cell ? (
            <FaRegCopy
              style={{ cursor: "pointer", marginLeft: 8 }}
              onClick={() => handleCopyNote(cell)}
              title="Copy Note"
            />
          ) : null}
        </div>
      ),
    },
    {
      dataField: "userRoleText",
      text: "User Role",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
    },
    {
      dataField: "date",
      text: "Date",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
      footer: "",
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="section-heading">Activity Details</h4>
      </div>

      <CardBody className="bg-light">
        <Row noGutters style={{ margin: "1rem 0 0 0" }}>
          <Col lg={12} className="pr-lg-3">
            {report.length > 0 ? (
              <div className="table-responsive activity-table-wrapper">
                <BootstrapTable
                  bootstrap4
                  keyField="slno"
                  data={report}
                  columns={columns}
                  bordered
                  condensed
                  hover
                  tabIndexCell
                  striped
                  search
                  expanded
                  expandable
                  searchable
                  classes="table-dashboard table-sm fs--1 border-bottom border-200 mb-0 table-dashboard-th-nowrap"
                  rowClasses="btn-reveal-trigger border-top border-200"
                  headerClasses="bg-200 text-900 border-y border-200"
                  noDataIndication={() => (
                    <div className="text-center py-4">No activity data found</div>
                  )}
                />
              </div>
            ) : (
              <div className="text-center py-5">
                <h5 className="text-muted">No Activity Data Available</h5>
                <p className="text-muted">
                  There are no activity records to display.
                </p>
              </div>
            )}
          </Col>
        </Row>
      </CardBody>
    </>
  );
}

export default withRouter(ActivityList);